(function () {
  console.log("BM PREFETCH FILE LOADED v2");

  if (window.__bmPrefetchProductsInitV2) {
    console.log("BM PREFETCH already init v2 - exit");
    return;
  }
  window.__bmPrefetchProductsInitV2 = true;
  console.log("BM PREFETCH INIT v2");

  const prefetched = new Set();

  function addPrefetch(url) {
    const abs = new URL(url, window.location.origin).href;
    if (prefetched.has(abs)) return;
    prefetched.add(abs);

    const link = document.createElement("link");
    // link.rel = "prefetch";
    link.rel = "preload";
    link.as = "document";
    link.fetchPriority = "high";
    link.href = abs;
    document.head.appendChild(link);

    console.log("BM PREFETCH ADDED:", abs);
    console.log("prefetch links:", document.querySelectorAll('link[rel="prefetch"]').length);
  }

  document.addEventListener(
    "mouseover",
    (e) => {
      const a = e.target.closest('[data-bm-prefetch="1"] a[href*="/products/"]');
      if (!a) return;

      console.log("BM PREFETCH MATCH:", a.getAttribute("href"));
      addPrefetch(a.getAttribute("href"));
    },
    true
  );
})();